import { DocumentoAssinarList } from "../documento/assinar/DocumentoAssinarList";
import { ISorgao, Orgao } from "../orgao/Orgao";
import { ISsetor, Setor } from "../setor/Setor";
import { IStipoDocumento, TipoDocumento } from "../tipoDocumento/TipoDocumento";
import { IStipoProcesso, TipoProcesso } from "../tipoProcesso/TipoProcesso";
import { Usuario } from "../usuario/Usuario";
import { ISusuarioList, UsuarioList } from "../usuario/UsuarioList";
import { ISprocesso, Processo } from "./Processo";

export interface Documento {
    id: string;
    processoId: string;
    tipoDocumento: TipoDocumento;
    nivelAcesso: "SIGILOSO" | "RESTRITO" | "PUBLICO";
    ativo: boolean;
    usuario: UsuarioList;
    nomeArvore: string | null;
    descricao: string | null;
    observacao: string | null;
    setores: Setor[] | null;
    dataHoraCriacao: Date | null;
    dataHoraAtualizacao: Date | null;
    interessados: Usuario[] | null;
    tipoArquivo: string;
    conteudo: string;
    numeroInterno: string
    orgao?: Orgao
    setor?: Setor;
    assinaturas?: DocumentoAssinarList[] | null
}

export const ISdocumento: Documento = {
    id: "",
    processoId: "",
    tipoDocumento: IStipoDocumento,
    nomeArvore: "",
    descricao: "",
    observacao: "",
    nivelAcesso: "RESTRITO",
    setores: [],
    dataHoraCriacao: null,
    dataHoraAtualizacao: null,
    ativo: true,
    usuario: ISusuarioList,
    interessados: [],
    tipoArquivo: "PDF",
    conteudo: "",
    numeroInterno: "",
    orgao: ISorgao,
    setor: ISsetor,
    assinaturas:[],
}